module.exports = __webpack_public_path__ + "static/media/FramePurpleSmall.3a671540.png";